import { createContext, useContext, useState, useEffect } from 'react';

const ThemeCtx = createContext({ theme: 'day', toggleTheme: () => {} });

export function ThemeProvider({ children }) {
  const [theme, setTheme] = useState(() => {
    try {
      const saved = localStorage.getItem('cng-theme');
      if (saved === 'day' || saved === 'night') return saved;
    } catch {}
    return window.matchMedia?.('(prefers-color-scheme: dark)').matches ? 'night' : 'day';
  });

  useEffect(() => {
    const html = document.documentElement;
    // Briefly suppress CSS transitions so tokens swap instantly
    html.setAttribute('data-theme-switching', '');
    html.setAttribute('data-theme', theme);
    try { localStorage.setItem('cng-theme', theme); } catch {}
    requestAnimationFrame(() =>
      requestAnimationFrame(() => html.removeAttribute('data-theme-switching'))
    );
  }, [theme]);

  const toggleTheme = () => setTheme(t => t === 'day' ? 'night' : 'day');

  return (
    <ThemeCtx.Provider value={{ theme, toggleTheme }}>
      {children}
    </ThemeCtx.Provider>
  );
}

export const useTheme = () => useContext(ThemeCtx);
